<template lang="pug">
#food_package
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_food_medicine.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_food_medicine_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 Food and Medical use
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 A flat plastic sheet is formed into a three-dimensional curved package by blister equipment which use high temperature and molds, so that consumers can directly see the product and protect it.
  section#product_profile
    b-row.menu
      b-col.text-center.position-relative(:class="{ active: p_show[1].show }" @click='change("APET")') PVC
      b-col.text-center(:class="{ active: p_show[0].show }" @click='change("PVC")') APET
    b-container.pt-md-4
      b-row#pvc_detail.detail.pb-5.py-md-5(:class="{ active: p_show[1].show }") 
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p The advantages of this product are excellent formability and impact resistance, and can prevent oxygen and moisture from permeating. It is suitable for packaging various foods or medicines.
          div
            h3 
              span Product Features
            ol
              li(v-for="item in p_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Information
            ol
              li(v-for="item in p_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
      b-row#apet_detail.detail.pb-5.py-md-5(:class="{ active: p_show[0].show }") 
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p The advantages of this product is excellent transparent appearance. It uses a non-toxic formula, and complies with health and safety regulations. It can be applied to general food or pharmaceutical packaging materials (such as cold water cups, cold water cup lids, chocolate boxes, fruit box, egg packaging box, refrigerated food box, cookie box, candy box, general food box, medicine package and needle medicine bottle packaging, etc.).
          div
            h3 
              span Product Features
            ol
              li(v-for="item in a_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Information
            ol
              li(v-for="item in a_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data_apet" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5(:class="{ active: p_show[1].show }") 
    div.mask
    h2.text-center 
      span PVC Specification
    b-container(fluid)
      //- swiper.swiper.py-5(:options="swiperOption_pvc").swiper_pvc.swiper_product_col_3
      swiper.swiper.py-5(:options="swiperOption_pvc").swiper_pvc.swiper_product_col_3
        swiper-slide(v-for="item in p_specification" :key="item.id")
          ul
            li 
              span {{ item.name }}
            li 
              span {{ item.feature }}
            li 
              span {{ item.outward }}
            li 
              span(v-html="item.thickness")
            li 
              span(v-html="item.proportion")
            li 
              span(v-html="item.pull")
            li 
              span(v-html="item.elongation")
            li 
              span(v-html="item.heating")
            li 
              span(v-html="item.vcm")
        div.swiper-pagination(slot="pagination")
  section#specification.py-5(:class="{ active: p_show[0].show }") 
    div.mask
    h2.text-center 
      span  APET Specification
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_apet").swiper_apet.swiper_product_col_5
        swiper-slide(v-for="item in a_specification" :key="item.id")
          ul
              li 
                span {{ item.name }}
              li 
                span {{ item.feature }}
              li 
                span {{ item.outward }}
              li 
                span(v-html="item.thickness")
              li 
                span(v-html="item.proportion")
              li 
                span(v-html="item.transmittance")
              li 
                span(v-html="item.gloss")
              li 
                span(v-html="item.mist")
        div.swiper-pagination(slot="pagination")
  section#others.py-5 
    b-container
      h3 Others
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
</template>
<script>
export default {
    metaInfo: {
        title: 'PVC / APET Foodstuff Packaging-NAN YA RIGID FILM',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'The advantages of PVC RIGID FILM are excellent formability and impact resistance, and can prevent oxygen and moisture from permeating. It is suitable for packaging various foods or pharmaceutica;s .PVC pharmaceutical packaging material has passed FDA certification, food-grade vacuum forming has anti-fog effect.The advantages of APET is excellent transparent appearance. It uses a non-toxic formula, and complies with health and safety regulations. It can be applied to general food or pharmaceutical packaging materials. There are AFVG(normal mold), AFVD(Deep mold), AFVM(microwave and baking use), etc.' },
            { name: 'Keywords', content: 'Nan Ya Plastics, Rigid Film, PVC, APET, Foodstuff Packaging, VFFP(pill use), Food Grade, Vacuum Molding' },
            { name: 'og:title', content: 'PVC / APET Foodstuff Packaging-NAN YA RIGID FILM' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com/' },
            { name: 'og:description', content: 'The advantages of PVC RIGID FILM are excellent formability and impact resistance, and can prevent oxygen and moisture from permeating. It is suitable for packaging various foods or pharmaceutica;s .PVC pharmaceutical packaging material has passed FDA certification, food-grade vacuum forming has anti-fog effect.The advantages of APET is excellent transparent appearance. It uses a non-toxic formula, and complies with health and safety regulations. It can be applied to general food or pharmaceutical packaging materials. There are AFVG(normal mold), AFVD(Deep mold), AFVM(microwave and baking use), etc.' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: 'Food and Medical use',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/application_Desktop/food_medicine_img_01.jpg',
            img_alt: 'Nan Ya Rigid PVC and APET food grades adopt non-toxic formula, comply with sanitation and safety regulations, and have antibacterial and anti-fog effects.' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/food_medicine_img_02.jpg',
            img_alt: 'Nan Ya Rigid PVC and APET food grades adopt non-toxic formula, comply with sanitation and safety regulations, and have antibacterial and anti-fog effects.' },
          { 
            id: '3',
            img_src: 'img/application_Desktop/food_medicine_img_03.jpg',
            img_alt: 'Nan Ya  PVC pharmaceutical packaging material has passed FDA certification.' }
        ],
        product_img_data_apet: [
          { 
            id: '4',
            img_src: 'img/application_Desktop/food_medicine_img_04.jpg',
            img_alt: 'Nan Ya APET is antibacterial and anti-fog, suitable as a protective mask.' },
          { 
            id: '1',
            img_src: 'img/application_Desktop/food_medicine_img_01.jpg',
            img_alt: 'Nan Ya Rigid PVC and APET food grades adopt non-toxic formula, comply with sanitation and safety regulations, and have antibacterial and anti-fog effects.' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/food_medicine_img_02.jpg',
            img_alt: 'Nan Ya Rigid PVC and APET food grades adopt non-toxic formula, comply with sanitation and safety regulations, and have antibacterial and anti-fog effects.' },
          { 
            id: '3',
            img_src: 'img/application_Desktop/food_medicine_img_03.jpg',
            img_alt: 'Nan Ya  PVC pharmaceutical packaging material has passed FDA certification.' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        p_feature: [
          { message: 'Produced with special non-toxic formula.' },
          { message: 'Comply with Taiwanese CNS, Japanese PL and American FDA food hygiene standards, which can ensure the hygiene of package.' },
          { message: 'Comply with the requirements of EU REACH and ROHS regulations.' },
          { message: 'Good vacuum formability.' },
          { message: 'Good resistance to chemicals.' },
          { message: 'Produce antistatic, anti-ultraviolet and high impact resistance products  according to customer\'s requirement.' }
        ],
        p_use: [
          { message: 'Customized items: tanning, corona, cold resistance, temperature resistance, weather resistance, flame resistance, antistatic and anti-fog, etc.' },
          { message: 'Inspection specifications: ASTM D-1593, ASTM D-792, JIS-K6734 and ASTM D-3680, etc. ' }
        ],
        a_feature: [
          { message: 'Non-toxic and environmentally friendly materials.' },
          { message: 'Good transparency.' },
          { message: 'Good vacuum formability. ' }
        ],
        a_use: [
          { message: 'Customized items: tanning, corona, cold resistance, anti-static, anti-fog, Antibacterial, high frequency, etc.' },
          { message: 'Inspection specifications: ASTM D-1593, ASTM D-792, ASTM D-1003 and ASTM D-523, etc.' }
        ],
        p_specification: [
          { 
            id: '1',
            name: 'VFFP(Pill Use)',
            feature: 'Features: Good formability, impact resistance, corrosion resistance',
            outward: 'Appearance: Transparent, colored',
            thickness: 'Thickness<sub>(mm)</sub>：0.25',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>:<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/><span class="pl-5">MD>135/CD>90</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/><span class="pl-5">MD-4~-7/CD<2</span>',
            vcm: 'VCM<sub>(ppm)</sub>：<1' },
          { 
            id: '2',
            name: 'VFVG(Normal Mold)',
            feature: 'Features: Good formability, impact resistance, corrosion resistance',
            outward: 'Appearance: Transparent, colored, shiny, matte',
            thickness: 'Thickness<sub>(mm)</sub> ：0.25',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>：<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub> ：<br/><span class="pl-5">MD>135/CD>90</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/><span class="pl-5">MD-6~-11/CD<1.5</span>',
            vcm: 'VCM(ppm)</sub>：<1' },
          { 
            id: '3',
            name: 'VFVD(Deep Mold)',
            feature: 'Features: Excellent ductility, good formability',
            outward: 'Appearance: Transparent, colored',
            thickness: 'Thickness<sub>(mm)</sub> ：0.25',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>：<br/> <span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/> <span class="pl-5">MD>135/CD>90</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/> <span class="pl-5">MD-5.5~-11/CD<1</span>',
            vcm: 'VCM<sub>(ppm)</sub>：<1' }
        ],
        a_specification: [
          { 
            id: '1',
            name: 'Antibacterial & anti-fog AYYG',
            feature: 'Features: Good transparency、硬挺、抗菌、防霧',
            outward: 'Appearance: Transparent',
            thickness: 'Thickness<sub>(mm)</sub> ：0.2~0.8 ',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.34±0.01',
            transmittance: 'VLT<sub>(Transparent Product,%)</sub>：<br/> <span class="pl-5">90</span>',
            gloss: 'anti-fog property<sub>(1 min no fog)</sub>：<br/> <span class="pl-5">50°C/95°C</span>',
            mist: 'Antibacterial <sub>(%)</sub>：<br/> <span class="pl-5">5 bacterials R>2.0</span>'},
          { 
            id: '2',
            name: 'AFVB(Economic Grade)',
            feature: 'Features: Good transparency, good formability',
            outward: 'Appearance: Transparent, colored',
            thickness: 'Thickness<sub>(mm)</sub>：0.40 ',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: 'VLT<sub>(Transparent Product,%)</sub>:<br/><span class="pl-5">88～92</span>',
            gloss: 'Gloss<sub>(Transparent Product)</sub>：<br/><span class="pl-5">158～168</span>',
            mist: 'HAZE<sub>(%)</sub>：<br/><span class="pl-5">≦3.0</span>'},
          { 
            id: '3',
            name: 'AFVG(Normal Mold)',
            feature: 'Features: Good transparency, good formability',
            outward: 'Appearance: Transparent, colored',
            thickness: 'Thickness<sub>(mm)</sub> ：0.40 ',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.34±0.01',
            transmittance: 'VLT<sub>(Transparent Product,%)</sub>：<br/><span class="pl-5">88～92</span>',
            gloss: 'Gloss<sub>(Transparent Product)</sub> ：<br/><span class="pl-5">158～168</span>',
            mist: 'HAZE<sub>(%)</sub>：<br/><span class="pl-5">≦3.0</span>' },
          { 
            id: '4',
            name: 'AFVD(Deep Mold)',
            feature: 'Features: Good transparency, good heat resistance during forming',
            outward: 'Appearance: Transparent, colored',
            thickness: 'Thickness<sub>(mm)</sub> ：0.40',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.34±0.01',
            transmittance: 'VLT<sub>(Transparent Product,%)</sub>：<br/> <span class="pl-5">88～92</span>',
            gloss: 'Gloss<sub>(Transparent Product)</sub>：<br/> <span class="pl-5">158～168</span>',
            mist: 'HAZE<sub>(%)</sub>：<br/> <span class="pl-5">≦3.0</span>'},
          { 
            id: '5',
            name: 'AFVM(Microwave and Baking Use)',
            feature: 'Features: good heat resistance ',
            outward: 'Appearance: Transparent, colored',
            thickness: 'Thickness<sub>(mm)</sub> ：0.50 ',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.34±0.01',
            transmittance: 'VLT<sub>(Transparent Product,%)</sub>：<br/> <span class="pl-5">88～92</span>',
            gloss: 'Gloss<sub>(Transparent Product)</sub>：<br/> <span class="pl-5">158～168</span>',
            mist: 'HAZE<sub>(%)</sub>：<br/> <span class="pl-5">≦3.0</span>'}
        ],
        swiperOption_pvc: {
          spaceBetween: 30,
          slidesPerView: 3,
          breakpoints: {
            1170: {
              spaceBetween: 30,
              slidesPerView: 'auto'
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption_apet: {
          slidesPerView: 4,
          spaceBetween: 30,
          breakpoints: {
            1550: {
              spaceBetween: 30,
              slidesPerView: 'auto',
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'2',
            name:'Antistatic Packaging',
            text:'Using blister equipment, using high temperature and molds, the flat plastic sheet is formed into a three-dimensional packaging curved shell, so that consumers can directly see the product and protect it.',
            url:'./img/application_Desktop/other_pic_2.jpg',
            href_link: 'anti_static'
          },
          {
            id:'3',
            name:'Decoration Materials',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing. Composite plastic building materials decoration products are made by hot pressing of multi-layer structure, generally 3-5 layer structure laminated, including wear-resistant layer (including UV treatment layer), printed decoration layer, middle material layer, base material layer, etc..',
            url:'./img/application_Desktop/other_pic_3.jpg',
            href_link: 'decoration'
          },
          {
            id:'4',
            name:'Card Lamination',
            text:'This product can be processed into various cards through printing, laminating, card punching, coding, and sub-card quality inspection.',
            url:'./img/application_Desktop/other_pic_4.jpg',
            href_link: 'card_Lamination'
          },
          {
            id:'5',
            name:'For Stationery',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing for majority of Printing process.',
            url:'./img/application_Desktop/other_pic_5.jpg',
            href_link: 'office_stationery'
          },
          {
            id:'6',
            name:'Cooling Tower',
            text:'Press working and forming process are good for the product.Forming process has to regulate quality.',
            url:'./img/application_Desktop/other_pic_6.jpg',
            href_link: 'water_treatment'
          },
          {
            id:'7',
            name:'Green Apet',
            text:'GREEN APET uses PCR resins made from recycled PET bottles as its raw material, reducing emissions of carbon and waste, providing consumers with an eco-friendly products.',
            url:'./img/application_Desktop/other_pic_7.jpg',
            href_link: 'green_apet'
          },
          {
            id:'8',
            name:'C-PET SHEET',
            text:'C-PET sheet is heated and further processed by compression molding machine so that the molded product can withstand high temperatures after crystallization.',
            url:'./img/application_Desktop/other_pic_8.jpg',
            href_link: 'Cpet-sheet'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'

</style>
